<template>
  <article class="view--overflow-visible">
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
          <div class="form js-form">
              <submenu></submenu>

              <TextBox label="Settings_Group_WebhookUrl"
                       v-model="tenant.webhookUrl"
                       modelPath="webhookUrl"
                       acc="webhookUrl"
                       tooltip="Webhook_Info_Tooltip" />

              <p v-html="L.localize('Webhook_Info')" />

              <p>
                  <ul>
                      <li>
                          {{ L.localize('Webhook_Info1') }}
                      </li>
                      <li>
                          {{ L.localize('Webhook_Info2') }}
                      </li>
                      <li>
                          {{ L.localize('Webhook_Info3') }}
                      </li>
                      <li>
                          {{ L.localize('Webhook_Info4') }}
                      </li>
                  </ul>

              </p>

                  <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
          </div>
      </div>
    </article>
  </article>
</template>

<script>
import L from 'services/Localization'
import Submenu from 'components/views/account/Submenu'
import notifications from 'mixins/notifications'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import File from 'services/File'
import TextBox from 'components/layout/forms/TextBox'
import Btn from 'components/layout/forms/Btn'

export default {
  name: 'webhook',
  components: { Submenu, TextBox, Btn },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      L: L,
      File: File,
      title: L.localize('Webhook_Breadcrumb_Index'),
      tenant: {
        name: '',
        description: '',
        webhookUrl: ''
      }
    }
  },
  created() {
    this.$store.dispatch('getTenantSession').then(() => {
      _.assign(this.tenant, this.currentTenant)
    })
  },
  computed: {
    ...mapGetters({
      currentTenant: 'getCurrentTenant'
    })
  },
  methods: {
    save() {
      this.loading = true
      var data = new FormData();
      data.append('name', this.tenant.name)
      data.append('description', this.tenant.description)
      data.append('beeClientId', this.tenant.beeClientId)
      data.append('beeClientSecret', this.tenant.beeClientSecret)
      data.append('webhookUrl', this.tenant.webhookUrl)
      this.$store.dispatch('updateTenant', data).then(
        // resolve
        () => {
          this.loading = false
          this.showNotification({
            title: L.localize('Label_SuccessCreation'),
            message: L.localize('Label_Success')
          })
          this.$store.dispatch('getTenantSession')
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Webhook.vue?84e1de2c